import { MdcBox, MdcCard, MdcCardContent, MdcGrid, MdcLink, MdcTypography } from 'ids-wc/dist/react/components';
import noResultsList from '@assets/no-results-list.svg';
import emptyListVector from '@assets/empty-state-list.svg';
import emptyCarouselVector from '@assets/empty-state-carousel.svg';
import emptyListDetailsVector from '@assets/empty-state-list-details.svg';
import { Trans } from 'react-i18next';

interface EmptyStateProps {
  type: 'list' | 'carousel' | 'list-details' | 'no-results';
  title: string;
  description?: string;
  suggestion?: string;
  link?: {
    i18nKey: string;
    url: string;
    linkLabel: string;
  };
}

const imageMap = {
  'no-results': noResultsList,
  list: emptyListVector,
  carousel: emptyCarouselVector,
  'list-details': emptyListDetailsVector
};

export const EmptyStateCard = (props: EmptyStateProps) => {
  const { type, title, description, suggestion, link } = props;

  return (
    <MdcCard background="surface-2">
      <MdcCardContent>
        <MdcGrid row>
          <MdcGrid col={12} colMd="auto">
            <img src={imageMap[type]} alt="Empty state illustration" />
          </MdcGrid>
          <MdcGrid col="flex">
            <MdcBox display="flex" direction="column" gap={1}>
              <MdcTypography variant="headline5" text={title} />
              {description && <MdcTypography variant="body1" text={description} />}
              {suggestion && <MdcTypography variant="body1" text={suggestion} />}
              {link && (
                <MdcGrid col={12} className="mt-2">
                  <Trans
                    i18nKey={link.i18nKey}
                    components={{
                      link: (
                        <MdcLink
                          icon="external"
                          href={link.url}
                          target="_blank"
                          label={link.linkLabel}
                          color="primary"
                        />
                      )
                    }}
                  />
                </MdcGrid>
              )}
            </MdcBox>
          </MdcGrid>
        </MdcGrid>
      </MdcCardContent>
    </MdcCard>
  );
};
